<template>
  <div class="container">
    <div class="page">
      <div class="header">
        <div class="header_top">
          <div>客户信息列表管理</div>
          <div>
            <div class="img">
              <img src="../assets/images/user.png">
            </div>
            <div>{{systemName}}</div>
          </div>
        </div>
      </div>
      <div class="table">
        <table cellspacing=0>
          <tr>
            <td>序号</td>
            <td>姓名</td>
            <td>邮箱</td>
            <td>手机号</td>
            <td>公司</td>
            <td>留言</td>
            <td>时间</td>
            <td>操作</td>
            <td>操作</td>
          </tr>
          <tr v-for="(item,i) of msgList" :key="i">
            <td> {{ item.messageId}} </td>
            <td> {{ item.username }} </td>
            <td> {{ item.email }} </td>
            <td> {{ item.mobile }} </td>
            <td> {{ item.company }} </td>
            <td> {{ item.messageDesc | ellipsis }} </td>
            <td> {{ item.createTime }} </td>
            <td>
              <el-button class="btn" type="text" @click="getMsg" :data-id="item.messageId">查看</el-button>
              <el-dialog
                :visible.sync="dialogVisible"
                width="760px"
                custom-class="dialog"
                :close-on-click-modal="false"
              >
                <div class="detail">
                  <div>
                    <span>姓 名:</span>
                    <span>{{ msg.username }}</span>
                  </div>
                  <div>
                    <span>邮 箱:</span>
                    <span>{{ msg.email }}</span>
                  </div>
                  <div>
                    <span>手机号:</span>
                    <span>{{ msg.mobile }}</span>
                  </div>
                  <div>
                    <span>公 司:</span>
                    <span>{{ msg.company }}</span>
                  </div>
                  <div>
                    <span>留 言:</span>
                    <span>{{ msg.messageDesc }}</span>
                  </div>
                </div>
              </el-dialog>
            </td>
            <td>
              <div class="img" @click="delMsg" :data-id="item.messageId">
                <img src="../assets/images/del.png">
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div class="bottom">
        <span>共{{total}}条记录</span>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          @prev-click="prevPage"
          @next-click="nextPage"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      systemId : sessionStorage.getItem("systemId"),
      systemName: '',
      token: sessionStorage.getItem("token"),
      msgList: [],
      msg: [],
      total: 0,
      currentPage:1
    };
  },
  created() {
    this.loadMore();
  },
  filters: {
    //超过20位显示 ...
    ellipsis: function(value) {
      if (!value) return "";
      if (value.length > 20) {
        return value.slice(0, 20) + "...";
      }
      return value;
    }
  }, 
  methods: {
    prevPage() {
      this.currentPage-=1
    },
    nextPage() {
      this.currentPage+=1
    },
    handleCurrentChange(val){
      this.currentPage = val
      this.loadMore();
    },
    delMsg(e) {
      var systemId = this.systemId;
      var token = this.token;
      var messageId = e.currentTarget.dataset.id;
      var url = "tyMessage/deleteMessage"
      var obj = {
        systemId,
        token,
        messageId
      }
      this.axios.post(url,this.qs.stringify(obj)).then(res=>{
        this.loadMore();
      })
    },
    getMsg(e) {
      var systemId = this.systemId;
      var token = this.token;
      this.dialogVisible = true;
      var messageId = e.currentTarget.dataset.id;
      var url = "tyMessage/getMessage"
      var obj = {
        systemId,
        token,
        messageId
      }
      this.axios.post(url,this.qs.stringify(obj)).then(res=>{
        this.msg = res.data.data
      })
    },
    loadMore() {
      var systemId = this.systemId;
      var token = this.token;
      this.systemName = sessionStorage.getItem("systemName").replace("\"", "").replace("\"", "");
      var url = "tyMessage/getMessages"
      var obj = {
        systemId,
        size:10,
        current:this.currentPage,
        token
      }
      this.axios.post(url,this.qs.stringify(obj)).then(res=>{
        this.msgList = res.data.data.records;
        this.total = res.data.data.total;
      })
    }
  }
};
</script>

<style scoped>
/* 页头 */
.header_top {
  display: flex;
  height: 72px;
  justify-content: space-between;
  font-size:16px;
  font-weight:500;
  color:rgba(47,84,235,1);
  line-height: 72px;
}
.header_top>div:first-child {
  margin-left: 32px;
}
.header_top>div:nth-child(2) {
  display: flex;
  margin-right: 32px;
}
.header_top>div:nth-child(2) .img {
  width: 28px;
  height: 28px;
  margin-top: 10px;
  margin-right: 12px;
}
/* 表格 */
/* 表头 */
.table>table {
  width: 100%;
  font-size: 16px;
  font-weight: 400;
  color:rgba(34,34,34,1);
}
.table>table>tr:first-child {
  height:48px;
  background:rgba(47,84,235,1);
  color: #fff;
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 10px;
}
.table>table .img {
  width: 14px;
  height: 14px;
  margin: 0 auto;
}
.table>table>tr:not(:first-child)>td {
  height: 65px;
  border-bottom: 1px solid #979797;
}
.table>table .btn {
  margin-top: 6px;
  color: #2F54EB;
  text-decoration: underline;
}
/* 留言查看详情 */
.detail {
  width: 740px;
  background:rgba(255,255,255,1);
  border-radius:16px;
  text-align: left;
}
.detail>div {
  margin-bottom: 33px;
}
.detail>div>span:first-child {
  width: 64px;
  height: 22px;
  display: inline-block;
  font-size:16px;
  font-weight:500;
  color:rgba(34,34,34,1);
  margin-right: 14px;
  margin-left: 22px;
}
.detail>div>span:nth-child(2) {
  font-size:16px;
  font-weight:400;
  color:#979797;
  line-height:22px;
}
.detail>div:last-child {
  display: flex;
}
.detail>div:last-child>span:nth-child(2) {
  line-height: 36px;
  display: block;
  width: 602px;
  margin-top: -6px;
}
.table /deep/ .dialog {
  border-radius:16px !important;
}
.table /deep/ .el-dialog {
  box-shadow: 0 0 0 !important;
}
/* 底部分页 */
.bottom {
  margin-top: 46px;
  margin-bottom: 42px;
  line-height: 26px;
}
.bottom>span {
  display: inline-block;
  width:115px;
  height:26px;
  border-radius:13px;
  border:1px solid rgba(47,84,235,1);
  font-size:14px;
  font-weight:500;
  color:rgba(47,84,235,1);
  line-height:26px;
  margin-right: 22px;
}
.bottom /deep/ li:not(.disabled).active {
  background-color: #2F54EB !important;
}
.bottom /deep/ .el-pager li:hover {
  color: #2F54EB !important;
}
.bottom /deep/ .el-pagination {
  display: inline-block;
}
</style>